import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  username = '';
  password = '';
  errorMessage = '';
  loading = false;
  showLoginForm = true; // 👈 controls whether to show the form

  constructor(private auth: AuthService, private router: Router) {}

  ngOnInit() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (token) {
      this.showLoginForm = false;
      this.loading = true;

      this.auth.saveToken(token);

      // Optional: small delay so navigation doesn’t race
      setTimeout(() => {
        this.router.navigate(['/dashboard/rfq/create']);
      }, 100);
    } else {
      // No token: redirect to portal
      window.location.href = environment.portal_url;
    }
  }

  // login() {
  //   if (!this.username || !this.password) {
  //     this.errorMessage = 'Username and password are required';
  //     return;
  //   }

  //   this.loading = true;
  //   this.errorMessage = '';  

  //   this.auth.login(this.username, this.password).subscribe({
  //     next: (res: any) => {
  //       this.auth.saveToken(res.access_token);
  //       this.router.navigate(['/dashboard/rfq/create']);
  //     },
  //     error: (err) => {
  //       this.loading = false;
  //       this.errorMessage = err.error.error_description || 'Invalid credentials';
  //     },
  //     complete: () => (this.loading = false),
  //   });
  // }

}
